module.exports = __webpack_public_path__ + "img/pho.cbda81e9.jpg";